// @ts-expect-error virtual file
import { addRouteMiddleware, defineNuxtPlugin, useHead } from '#imports'
import { useLocale } from '../composables/locale'
import { useUserSession } from '../composables/userSession'

export default defineNuxtPlugin(async (nuxt) => {
  const { ready, locale, loadedTranslationsLocaleId, fetch, fetchTranslations, setLocale } = useLocale()
  const { user } = useUserSession()

  useHead({
    htmlAttrs: {
      lang: () => locale.value?.code,
    },
  })

  addRouteMiddleware('_localeMiddleware', async () => {
    if (!ready.value) {
      await nuxt.runWithContext(() => fetch())
    }

    nuxt.runWithContext(() => setLocale(user.value?.locale?.id || locale.value.id))
    if (loadedTranslationsLocaleId.value !== locale.value.id) {
      await nuxt.runWithContext(() => fetchTranslations())
    }
  }, { global: true })
})
